var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"memberAnalytics"}},[_c('md-empty-state',{staticClass:"md-primary",attrs:{"md-icon":"query_stats","md-label":"Nothing in Done","md-description":"Anything you mark done will be safely stored here."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }